import React from 'react';
import AppRouter from './AppRouter';
import './index.css';

const App: React.FC = () => {
  return <AppRouter />;
};

export default App;
